import Arrow from 'assets/image/icons/svg/icons/arrow-down-thin.svg'
import { memo } from 'react'
import {
	components,
	type DropdownIndicatorProps,
	type GroupBase
} from 'react-select'

import css from './CustomSelect.module.scss'

const DropdownIndicator_ = <
	Option_2,
	IsMulti_2 extends boolean,
	Group_2 extends GroupBase<Option_2>
>(
	props: DropdownIndicatorProps<Option_2, IsMulti_2, Group_2>
) => (
	<components.DropdownIndicator {...props}>
		<img alt='arrow' className={css.arrow} height={6} src={Arrow} width={10} />
	</components.DropdownIndicator>
)

export const DropdownIndicator = memo(DropdownIndicator_)
